module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "demo-table-sort"
    }
  }, [_c('hrms-table', {
    attrs: {
      "columns": _vm.columns[_vm.nowLang].index,
      "data": _vm.index
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3d1c33b4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/demo/demoTableSort.vue
// module id = 3702
// module chunks = 1